var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1484_16693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 18.7531L22.4734 18.5531C21.8305 17.98 21.2677 17.323 20.8 16.5998C20.289 15.6017 19.983 14.5114 19.9 13.3931V10.0998C19.9044 8.34351 19.2674 6.64609 18.1085 5.32642C16.9497 4.00675 15.3488 3.15568 13.6067 2.93311V2.07311C13.6067 1.83706 13.5129 1.61069 13.346 1.44378C13.1791 1.27687 12.9527 1.18311 12.7167 1.18311C12.4806 1.18311 12.2543 1.27687 12.0874 1.44378C11.9205 1.61069 11.8267 1.83706 11.8267 2.07311V2.94644C10.1002 3.18506 8.51867 4.04128 7.37504 5.35651C6.23142 6.67174 5.60318 8.35687 5.60669 10.0998V13.3931C5.52373 14.5114 5.21771 15.6017 4.70669 16.5998C4.24728 17.3213 3.69349 17.9783 3.06003 18.5531L2.83336 18.7531V20.6331H22.7V18.7531Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0134 21.3335C11.0718 21.7561 11.2812 22.1432 11.6029 22.4235C11.9245 22.7037 12.3367 22.8581 12.7634 22.8581C13.19 22.8581 13.6022 22.7037 13.9238 22.4235C14.2455 22.1432 14.4549 21.7561 14.5134 21.3335H11.0134Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1484_16693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.800018)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.0d23b6e6ca2daeba2b0c3d0cb4513ff0.svg";
export { ForwardRef as ReactComponent };